<script>

    import forEach from 'lodash/forEach';
    import isDark from 'chromatic-luminance';

    export default {
        data(){
            return {
                chosen_calendars : [],
                is_created : false,
            }
        },

        methods: {
            init_chosen() {


                var vm = this;

                $(this.$refs.calendars_select).chosen({
                    no_results_text: trans('global.no_search_results')
                 }).on('change', (evt, params) => {
                    var update_val = $(this.$refs.calendars_select).val() ? $(this.$refs.calendars_select).val() : [];
                    this.chosen_calendars = update_val;
                });

                $(document).on('chosen:updated', vm.$refs.calendars_select, function(){

                    $(vm.$refs.calendars_select).next('.chosen-container').find('.search-choice').each(function( index ) {
                        var cal_name = $(this).find('span').text().trim();
                        var color = $(vm.$refs.calendars_select).find('option:selected').filter(function () { return $(this).text().trim() == cal_name; }).first().attr('data-color');
                        $(this).css('background-color', color);
                        $(this).css('color',  isDark(color) ? '#FFFFFF' : '#000000');
                        $(this).find('.search-choice-close').css('color',  isDark(color) ? '#FFFFFF' : '#000000');
                    });

                });

                this.$nextTick(function(){
                    $(this.$refs.calendars_select).trigger('chosen:updated');
                });

                this.is_created = true;
            },
        },

        mounted() {
            this.$store.dispatch('calendars/loadCalendars');
            this.init_chosen();
        },

        props: {
            value: {
                required: true,
            }
        },

        watch: {
            value(val) {
                var vm = this;
                var new_chosen_calendars = [];

                forEach(val, (calendar) => {
                    new_chosen_calendars.push(calendar.id);
                });

                this.$nextTick(() => {
                    $(this.$refs.calendars_select).val(new_chosen_calendars);
                    $(this.$refs.calendars_select).trigger('chosen:updated');
                });
            },

            chosen_calendars(value, oldValue) {
                var chosen_calendars_objects = [];

                forEach(this.all_calendars, calendar => {
                    forEach(value, new_calendar_id => {
                        if (calendar.id == new_calendar_id) {
                            chosen_calendars_objects.push(calendar);
                        }
                    });
                });

                this.$emit('input', chosen_calendars_objects);
            },

            all_calendars(value, oldValue) {
                this.$nextTick(() => {
                    this.init_chosen();
                });
            },
        },

        computed: {
            all_calendars() {
                return this.$store.getters['calendars/getCalendars']();
            },
        }
    };
</script>

<template id="calendars-select">
    <select class="form-control calendars-select" style="width: 100%;" multiple ref="calendars_select" v-model="chosen_calendars" v-if="all_calendars.length > 0">

        <option :data-color="calendar.color" v-for="calendar in all_calendars" :value="calendar.id" :key="calendar.id">
            {{ calendar.name }}
        </option>

    </select>
</template>
